/**
 * True when Clerk FAPI rejected the call because there is no usable
 * session (`authentication_invalid` / "need to supply an active session").
 *
 * Distinct from infrastructure failures: the client may still hold a
 * stale session object while FAPI has already ended the session.
 *
 * @see https://clerk.com/docs/guides/development/errors/frontend-api
 */
export function isClerkNoActiveSessionError(err: unknown): boolean {
  if (!err || typeof err !== 'object') return false;

  const { code, message, errors } = err as {
    code?: unknown;
    message?: unknown;
    errors?: Array<{
      code?: unknown;
      message?: unknown;
      longMessage?: unknown;
    }>;
  };

  if (code === 'authentication_invalid') return true;
  if (errors?.[0]?.code === 'authentication_invalid') return true;

  const candidates = [message, errors?.[0]?.message, errors?.[0]?.longMessage];
  return candidates.some(
    value =>
      typeof value === 'string' &&
      /need to supply an active session/i.test(value)
  );
}
